/* * @Author: 曹俊杰 * @Date: 2024-09-29 15:23:19 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-21 02:20:39 */合同宝Icon

<template>
  <div class="hetongbao">
    <div v-if="value === 0" class="type0">--</div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 1" class="type1 item">
      <div class="icon"></div>
      <span style="margin-left: 0">不可投保</span>
    </div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 2" class="type2 item">
      <div class="icon"></div>
      <span>保障中</span>
    </div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 3" class="type3 item">
      <div class="icon"></div>
      <span>已到期</span>
    </div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 4" class="type4 item">
      <div class="icon"></div>
      <span>启动维权</span>
    </div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 5" class="type5 item">
      <div class="icon"></div>
      <span>部分退款</span>
    </div>
    <!-- -------------------------------------- -->
    <div v-else-if="value === 6" class="type5 item">
      <div class="icon"></div>
      <span>全额退款</span>
    </div>
    <div v-else class="none">--</div>
  </div>
</template>
<script>
import selectData from "@/mixins/selectData.js";
export default {
  mixins: [selectData],
  props: {
    value: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.hetongbao {
  font-family: "Noto Sans SC";
  .item {
    display: flex;
    align-items: center;
    gap: 4px;
    .icon {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #999999;
    }
  }
  .type2 {
    .icon {
      background: #00c152;
    }
  }
  .type3 {
    .icon {
      background: #722ed1;
    }
  }
  .type4 {
    .icon {
      background: #f77234;
    }
  }
  .type5 {
    .icon {
      background:s #f45858;
    }
  }
}
</style>
